import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Mail, MessageCircle, Phone, ExternalLink } from "lucide-react";

const HelpSupport = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-slate-50 pb-24" data-testid="help-support-page">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-4 py-4">
          <div className="flex items-center gap-3">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate("/dashboard")}
              data-testid="back-to-dashboard"
            >
              <ArrowLeft className="w-5 h-5" />
            </Button>
            <h1 className="text-xl font-bold text-slate-900">Aide / Support</h1>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-6 space-y-6">
        <Card data-testid="support-contact-card">
          <CardHeader className="pb-3">
            <CardTitle className="text-lg flex items-center gap-2">
              <MessageCircle className="w-5 h-5 text-sky-600" />
              Support AquaReport
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-sm text-slate-600">
              Pour toute question ou assistance concernant l'utilisation d'AquaReport, veuillez contacter notre support.
            </p>

            <div className="bg-sky-50 border border-sky-200 rounded-lg p-4 space-y-3">
              <div className="flex items-center gap-3">
                <div className="bg-sky-100 rounded-lg p-2">
                  <Mail className="w-5 h-5 text-sky-600" />
                </div>
                <div>
                  <p className="text-xs text-slate-500 uppercase tracking-wide">Email</p>
                  <a
                    href="mailto:support@aquareport.re"
                    className="text-sm font-medium text-sky-700 hover:text-sky-800"
                    data-testid="support-email-link"
                  >
                    support@aquareport.re
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-slate-50 border border-slate-200 rounded-lg p-4">
              <h3 className="text-sm font-semibold text-slate-800 mb-2">Questions fréquentes</h3>
              <ul className="space-y-2 text-sm text-slate-600">
                <li className="flex items-start gap-2">
                  <span className="text-sky-500 mt-0.5">-</span>
                  <span><strong>Créer un rapport :</strong> Depuis le tableau de bord, cliquez sur "Nouveau dossier" et suivez les étapes du formulaire.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-sky-500 mt-0.5">-</span>
                  <span><strong>Générer un PDF :</strong> Ouvrez un dossier complété et cliquez sur "Télécharger PDF".</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-sky-500 mt-0.5">-</span>
                  <span><strong>Envoyer un rapport :</strong> Depuis la fiche du dossier, utilisez le bouton "Envoyer par email".</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-sky-500 mt-0.5">-</span>
                  <span><strong>Mon compte :</strong> Accédez à vos informations et changez votre mot de passe depuis le menu "Mon compte".</span>
                </li>
              </ul>
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default HelpSupport;
